import React, { useState } from 'react'
import { Card } from 'reactstrap';
import Sidebar from 'views/pages/manage/businessArea/component/FirstForm/Sidebar';
import { columns, flatMap, menuItems } from './constant';
import ListComponent from './ListComponent';
import MappingListing from './MappingListing';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import EmprConfigHeaderCard from 'views/pages/manage/masters/studentFinancials/epmrConfigs/EpmrConfigHeader';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetPermissions } from 'layouts/customHook';
const UserMapping = () => {
    const [selectedTab, setSelectedTab] = useState(menuItems[0])

    const [rowForm, setRowForm] = useState({});
    const userPermissions = useGetPermissions('userMappings');
    const handleTabChange = (item) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
            return;
        }
        setSelectedTab(item);

    }
    return  (  userPermissions
           ?<> <EmprConfigHeaderCard
            isConfig={false}
            heading='Mapping master'
            headingClassName='large-text'
        />
        <div className="d-flex mr-2 mt-2" style={{ height: '76vh', overflow: 'hidden' }}>
            {/* Sidebar in a Card */}
            <Sidebar
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                handleTabChange={handleTabChange}
                fieldMap={flatMap}
                menuItems={menuItems}
            />
            <MappingListing selectedTab={selectedTab} rowForm={rowForm} setRowForm={setRowForm} />
        </div>
    </>: <PermisionDenied/>
    )
}
export default UserMapping;